import { YodaSpacing } from 'yoda-ui/yodaTheme';

export const sideContainerStyle = {
  visibleBox: {
    marginTop: YodaSpacing.large,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  hiddenBox: {
    height: 0,
    marginTop: 0,
    visibility: 'hidden',
  },
};

